import { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import $ from "jquery";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { ecommerceapiUrl } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";

var module = "ownrider";
var moduleName = "Own Rider";
var modulePath = "/clientpanel/own-rider";
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.EditID || '',
      pageloading: false,
      postdata: {
        riderFirstName: "",
        riderLastName: "",
        riderPhone: "",
        riderEmailID: "",
        riderStatus: "",
      },
      loading: true,
      formpost: [],
      companyDetail: [],
    };
  }
  componentDidMount() {
    if (this.state.editID !== "") {
      var params = {
        params: "",
        url: `${ecommerceapiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0]?.message ?? "";
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var riderStatus = result.riderStatus === "A" ? "Active" : "Inactive";
          var status =
            result.riderStatus !== "" && result.riderStatus !== null
              ? {
                  label: riderStatus,
                  value: result.riderStatus,
                }
              : [];
          var clientupdatedata = {
            riderFirstName: result.riderFirstName,
            riderLastName: result.riderLastName,
            riderPhone: result.riderPhone,
            riderEmailID: result.riderEmailID,
            riderStatus: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: value } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;
    var postObject = {
      riderFirstName: postData.riderFirstName,
      riderLastName: postData.riderLastName,
      riderPhone: postData.riderPhone,
      riderEmailID: postData.riderEmailID,
      riderStatus: postData?.riderStatus?.value ?? "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method, "ecom");
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"own-rider"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method, urlType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method, urlType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

const isEmpty = (value) => (value === "" ? "This field is required." : null);
const isSingleSelect = (value) => {
  return Object.keys(value).length > 0 ? null : "This field is required.";
};

function validationConfig(props) {
  const { riderFirstName, riderPhone, riderStatus } = props.fields;

  return {
    fields: ["riderFirstName", "riderPhone", "riderStatus"],

    validations: {
      riderFirstName: [[isEmpty, riderFirstName]],
      riderPhone: [[isEmpty, riderPhone]],
      riderStatus: [[isSingleSelect, riderStatus]],
    },
  };
}

class PostForm extends Component {
  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgFname,
      errMsgriderPhone,
      errMsgStatus = "";
    if ($validation.riderFirstName.error.reason !== undefined) {
      errMsgFname = $validation.riderFirstName.show && <span className="error">{$validation.riderFirstName.error.reason}</span>;
    }
    if ($validation.riderPhone.error.reason !== undefined) {
      errMsgriderPhone = $validation.riderPhone.show && <span className="error">{$validation.riderPhone.error.reason}</span>;
    }
    if ($validation.riderStatus.error.reason !== undefined) {
      errMsgStatus = $validation.riderStatus.show && <span className="error">{$validation.riderStatus.error.reason}</span>;
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={errMsgFname !== "" && errMsgFname !== false && errMsgFname !== undefined ? "form-control is-invalid" : "form-control"}
                name="riderFirstName"
                id="riderFirstName"
                value={fields.riderFirstName}
                {...$field("riderFirstName", (e) => onChange("riderFirstName", e.target.value))}
              />
              <label htmlFor="riderFirstName">
                Frist Name<span className="error">*</span>
              </label>
              {errMsgFname}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input type="text" className="form-control" name="riderLastName" value={fields.riderLastName} {...$field("riderLastName", (e) => onChange("riderLastName", e.target.value))} />
              <label htmlFor="riderLastName">Last Name</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="riderEmailID"
                id="riderEmailID"
                value={fields.riderEmailID}
                {...$field("riderEmailID", (e) => onChange("riderEmailID", e.target.value))}
              />
              <label htmlFor="riderEmailID">
                Email<span className="error">*</span>
              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={errMsgriderPhone !== "" && errMsgriderPhone !== false && errMsgriderPhone !== undefined ? "form-control is-invalid" : "form-control"}
                name="riderPhone"
                value={fields.riderPhone}
                {...$field("riderPhone", (e) => onChange("riderPhone", e.target.value))}
              />
              <label htmlFor="riderPhone">Mobile</label>
              {errMsgriderPhone}
            </div>
          </div>
          <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.riderStatus}
                onChange={this.handleSelectChange.bind(this, "riderStatus")}
                placeholder="Select Status *"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "Inactive" },
                ]}
              />
              {errMsgStatus}
            </div>
          </div>

          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
